import { render, staticRenderFns } from "./SalesForecastEdit.vue?vue&type=template&id=36136765&"
import script from "./SalesForecastEdit.vue?vue&type=script&lang=js&"
export * from "./SalesForecastEdit.vue?vue&type=script&lang=js&"
import style0 from "./SalesForecastEdit.vue?vue&type=style&index=0&id=36136765&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports